var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell-02",
    transform: "translate(-32.000000, -21.000000)",
    fill: "#303133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Left",
    transform: "translate(32.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00142575,0.666666667 L0.666666667,2.81994267 L1.07870775,4.15371945 L8.00142575,2.12587701 L14.9269952,4.15371945 L15.3333333,2.81994267 L8.00142575,0.666666667 Z M0.87268721,5.57739029 L0.87268721,13.2427741 C5.86280419,13.2427741 8.00142575,15.3333333 8.00142575,15.3333333 C8.00142575,15.3333333 10.1400473,13.2427741 15.1301643,13.2427741 L15.1301643,5.57739029 C10.1400473,5.57739029 8.00142575,7.66794951 8.00142575,7.66794951 C8.00142575,7.66794951 5.86280419,5.57739029 0.87268721,5.57739029 Z M2.29843492,7.03660062 C5.52846635,7.33833801 6.94066945,8.60452004 6.99342212,8.65329976 L7.28855189,8.95015917 L7.28855189,13.2239591 C6.18858754,12.6685672 4.56252228,12.085998 2.29843492,11.9034225 L2.29843492,7.03660062 Z M13.7044166,7.03660062 L13.7044166,11.9034225 C11.4403292,12.085998 9.81426396,12.6685672 8.7142996,13.2239591 L8.7142996,8.94179693 L8.99588477,8.66723682 C9.06218204,8.60730745 10.4715337,7.33833801 13.7044166,7.03660062 Z",
    id: "icons8-school"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.014b19bc.svg";
export { ForwardRef as ReactComponent };